import { render } from "./VendorChat.vue?vue&type=template&id=f0e2993e"
import script from "./VendorChat.vue?vue&type=script&lang=js"
export * from "./VendorChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__